import React, { FC } from "react";

import { GreenCheckMark } from "@/assets/icons";
import { InsuredGoodRootCategory } from "@/components/features/InsuredGoods/utils/InsuredGoodRootCategory";
import { InsuredGood } from "@/shared/domain";

import { StyledRiskObjectCard } from "./styled";

type ReportClaimRiskCardProps = {
    insuredGood: InsuredGood;
    onSelect: () => void;
    isSelected?: boolean;
};
const ReportClaimRiskCard: FC<ReportClaimRiskCardProps> = ({ insuredGood, onSelect, isSelected = false }) => {
    const { name, type, category } = insuredGood;

    return (
        <StyledRiskObjectCard
            $isSelected={isSelected}
            data-testid={`report_claim_risk_card-item-${insuredGood.id}`}
            onClick={onSelect}
        >
            {InsuredGoodRootCategory.getFromId(category.id).categoryIcon}
            {isSelected && <GreenCheckMark data-testid="green-check-mark" className="checkIcon" />}
            <div className="ml10 align-center riskObjectCardInfo ">
                <div className=" mb10">
                    <div className="typeName highlightText">{category.name}</div>
                </div>

                <div className="riskObjectName highlightText"> {name}</div>
                <div className="policyholderName highlightText">{type.name}</div>
            </div>
        </StyledRiskObjectCard>
    );
};

export default ReportClaimRiskCard;
